import React, { useEffect, useState } from 'react'
import { Popover } from 'antd'
import { UnorderedListOutlined, ExpandOutlined, CompressOutlined } from '@ant-design/icons'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'
import SelectLang from '@/components/selectLang'
import { Row, Col } from 'antd'
import { clearAuthentication, redirectURL } from '@/utils/authHelp'
import { modalConfirm } from '@/utils/modalUtils'
import { formatMessageNew, exitFullscreen, isFullScreen } from '@/utils/common'

import '@/pages/layout/header/Header.less'

const PhoneHeader = props => {
  const userName = useSelector(state => state.commonStore.userName) || ''
  const isMenuShow = useSelector(state => state.commonStore.isMenuShow)
  useEffect(() => {
    if (isMenuShow) {
      hide()
    }
  }, [isMenuShow])
  const showLogoutModal = () => {
    modalConfirm({ content: formatMessageNew('languageObj.loginLocale.logoTip') }, () => {
      handelLogoutOk()
    })
  }

  const handelLogoutOk = () => {
    logout()
  }

  const logout = () => {
    let id_token = localStorage.getItem('nfcOauthIdToken')
    clearAuthentication()
    if (id_token) {
      window.location.href = `${process.env.REACT_APP_OKTA_LOGOUT_URL}${id_token}&post_logout_redirect_uri=${redirectURL}`
    } else {
      props.history.push('/login')
    }
  }

  const renderUser = () => {
    return (
      <div className="user-container">
        <span className="header-item">{userName}</span>
        <span onClick={() => showLogoutModal()} className="header-item header-link">
          {formatMessageNew('languageObj.loginLocale.logout')}
        </span>
      </div>
    )
  }
  const [open, setOpen] = useState(false)
  const [fullScreen, setFullScreen] = useState(false)
  const hide = () => {
    setOpen(false)
  }
  const handleOpenChange = newOpen => {
    setOpen(newOpen)
  }

  const zoomInOrOutHtml = () => {
    return (
      <div
        id="zoomInOrOut"
        style={{ marginLeft: '20px' }}
        onClick={() => {
          if (fullScreen) {
            setFullScreen(false)
            if (isFullScreen()) {
              exitFullscreen()
            }
          } else {
            setFullScreen(true)
            if (!isFullScreen()) {
              props.openFullscreen()
            }
          }
        }}
      >
        {fullScreen ? <CompressOutlined /> : <ExpandOutlined />}
      </div>
    )
  }

  return (
    <div className="gnav">
      <div className="gnav-bar">
        <Row type="flex" justify="space-between" align="middle">
          <Col span={2}>
            {/* <Logo link="/" /> */}
            <Popover
              content={props.contentView}
              // title="Title"
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
            >
              <UnorderedListOutlined style={{ fontSize: '20px', padding: '12px' }} />
            </Popover>
          </Col>
          {/* <Col span={14}>{props.children}</Col> */}
          <Col span={14} className="tool-bar">
            {/* {props.fullDom} */}
            {props.authenticated && renderUser()}
            <SelectLang />
            {zoomInOrOutHtml()}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default withRouter(PhoneHeader)
